module.exports = __webpack_public_path__ + "static/media/brossard_logo.ea421bad.ico";